import { useState, useEffect, useRef } from 'react';

export const useCard = () => {
  const cardRef = useRef<HTMLDivElement>(null);
  const headerRef = useRef<HTMLDivElement>(null);
  const [cardRowsHeight, setCardRowsHeight] = useState('20vh');

  const calculateHeight = () => {
    if (!cardRef.current || !headerRef.current) {
      return;
    }

    const height =
      cardRef.current.offsetHeight - headerRef.current.offsetHeight;

    setCardRowsHeight(`${height}px`);
  };

  useEffect(() => {
    calculateHeight();

    window.addEventListener('resize', calculateHeight);

    return () => {
      window.removeEventListener('resize', calculateHeight);
    };
  }, []);

  return {
    cardRef,
    headerRef,
    cardRowsHeight,
  };
};
